'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _navigation = require('program/frontend/actions/navigation');

var _List = require('material-ui/List');

var _trackingBar = require('../components/tracking-bar');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var styles = {

  active: {
    backgroundColor: "rgba(0, 0, 0, 0.27)"
  },

  trackingBar: {
    position: "absolute",
    bottom: 14,
    height: 2,
    left: 16,
    right: 16,
    backgroundColor: "rgba(0,0,0,0.1)",
    opacity: 0.66
  }

};

var Video = _react2['default'].createClass({

  displayName: "Video",

  mixins: [_reactAddonsPureRenderMixin2['default']],

  getMyRoute: function getMyRoute() {
    var videoId = this.props.videoId;


    return "/v/" + encodeURIComponent(videoId);
  },
  handleTap: function handleTap() {
    var dispatch = this.props.dispatch;


    dispatch((0, _navigation.navigateTo)(this.getMyRoute()));
    dispatch((0, _navigation.setOpenSidebar)(false));
  },
  render: function render() {
    var _props = this.props,
        pathname = _props.pathname,
        title = _props.title,
        nestedLevel = _props.nestedLevel,
        videoId = _props.videoId;


    var active = pathname === this.getMyRoute();

    var inner = _react2['default'].createElement(
      'div',
      null,
      title,
      _react2['default'].createElement(_trackingBar.TrackingBar, {
        videoId: videoId,
        style: styles.trackingBar
      })
    );

    return _react2['default'].createElement(_List.ListItem, {
      style: active ? styles.active : undefined,
      primaryText: inner,
      nestedLevel: nestedLevel,
      disabled: !videoId,
      onTouchTap: this.handleTap
    });
  }
});

exports.Video = Video = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    pathname: state.router.location.pathname
  };
})(Video);

exports.Video = Video;


//////////////////
// WEBPACK FOOTER
// ./program/frontend/sidebar/video.jsx
// module id = 969
// module chunks = 0